export enum TopEnum {
    Top = 1,
    Other = 2
}
